import React, { useState } from 'react';
import { Briefcase, Mail, RefreshCw, CheckCircle, Loader } from 'lucide-react';
import { resendVerification } from '../services/api';
import { useApp } from '../context/AppContext';
import './EmailVerificationScreen.css';

export default function EmailVerificationScreen({ email }) {
  const { confirmEmailCode, setPendingVerificationEmail } = useApp();
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [resendStatus, setResendStatus] = useState('idle'); // idle | loading | sent | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      // Bei Erfolg ist der Nutzer angemeldet; das Setup-Gate in App.js
      // leitet automatisch zur Profil-Einrichtung weiter
      await confirmEmailCode(email, code);
    } catch (err) {
      setError(err.response?.data?.error || 'Ungültiger oder abgelaufener Code.');
      setSubmitting(false);
    }
  };

  const handleResend = async () => {
    setResendStatus('loading');
    setError(null);
    try {
      await resendVerification(email);
      setResendStatus('sent');
    } catch {
      setResendStatus('error');
    }
  };

  return (
    <div className="email-verify-screen">
      <div className="email-verify-card animate-fadeInUp">
        <div className="email-verify-logo">
          <Briefcase size={22} />
        </div>

        <div className="email-verify-icon">
          <Mail size={48} strokeWidth={1.5} />
        </div>

        <h1 className="email-verify-title">Bestätige deine E-Mail ✉️</h1>

        <p className="email-verify-text">
          Wir haben einen 6-stelligen Code an
        </p>
        <p className="email-verify-email">{email}</p>
        <p className="email-verify-text">
          gesendet. Gib ihn hier ein, um dein Konto zu aktivieren.
        </p>

        <form className="email-verify-form" onSubmit={handleSubmit}>
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6}"
            maxLength={6}
            placeholder="123456"
            className="email-verify-code-input"
            value={code}
            onChange={e => { setCode(e.target.value.replace(/\D/g, '')); setError(null); }}
            disabled={submitting}
            autoFocus
            required
          />
          {error && <p className="email-verify-error">{error}</p>}
          <button
            type="submit"
            className="email-verify-submit"
            disabled={submitting || code.length !== 6}
          >
            {submitting
              ? <><Loader size={16} className="spin" /> Wird geprüft...</>
              : 'Code bestätigen'}
          </button>
        </form>

        <div className="email-verify-divider" />

        {resendStatus === 'sent' ? (
          <div className="email-verify-sent">
            <CheckCircle size={16} />
            Neuer Code wurde gesendet!
          </div>
        ) : (
          <div className="email-verify-resend">
            <span>Keinen Code erhalten?</span>
            <button
              className="email-verify-resend-btn"
              onClick={handleResend}
              disabled={resendStatus === 'loading'}
            >
              {resendStatus === 'loading'
                ? <><RefreshCw size={14} className="spin" /> Wird gesendet...</>
                : 'Code erneut senden'}
            </button>
          </div>
        )}

        {resendStatus === 'error' && (
          <p className="email-verify-error">
            Fehler beim Senden. Bitte versuche es später erneut.
          </p>
        )}

        <button
          className="email-verify-cancel"
          onClick={() => setPendingVerificationEmail(null)}
        >
          Abbrechen
        </button>
      </div>
    </div>
  );
}
